import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Radio,
  Typography,
  Divider,
  Box
} from '@mui/material';

const models = {
  "ARIMA": { 
    description: "Zaman serisi analizi için geleneksel istatistiksel model",
    advantages: "Basit veri setleri için hızlı ve etkili",
    complexity: "Düşük"
  },
  "Prophet": { 
    description: "Facebook tarafından geliştirilen, trend ve mevsimsellik tespiti yapabilen bir model",
    advantages: "Mevsimselliğe duyarlı, eksik verileri tolere edebilir",
    complexity: "Orta"
  },
  "LSTM": { 
    description: "Uzun kısa süreli bellek ağları kullanan derin öğrenme modeli",
    advantages: "Karmaşık desenler ve uzun vadeyi öğrenebilir",
    complexity: "Yüksek"
  },
  "RandomForest": { 
    description: "Çok sayıda karar ağacı kullanarak tahmin yapan topluluk modeli",
    advantages: "Aşırı öğrenmeye karşı dirençli, birden fazla değişkenle çalışabilir",
    complexity: "Orta"
  },
  "XGBoost": { 
    description: "Gradyan artırmalı karar ağaçları kullanan makine öğrenmesi algoritması",
    advantages: "Yüksek performans, çok sayıda hiperparametre ile ince ayar",
    complexity: "Yüksek"
  }
};

const ModelSelectionDialog = ({ open, onClose, currentModel }) => {
  const [selectedModel, setSelectedModel] = useState(currentModel || 'LSTM');

  const handleClose = () => {
    onClose(null);
  };

  const handleSelect = () => {
    onClose(selectedModel);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Model Seçimi</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" paragraph>
          Talep tahmini için kullanılacak modeli seçin. Farklı modeller, veri setinize bağlı olarak çeşitli performans özellikleri sunabilir.
        </Typography>
        
        <List sx={{ width: '100%' }}>
          {Object.entries(models).map(([modelName, details]) => (
            <React.Fragment key={modelName}>
              <ListItem disablePadding>
                <ListItemButton 
                  onClick={() => setSelectedModel(modelName)}
                  selected={selectedModel === modelName}
                  sx={{ 
                    borderRadius: 1,
                    transition: 'all 0.2s',
                    '&:hover': {
                      backgroundColor: 'rgba(63, 81, 181, 0.08)',
                    },
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(63, 81, 181, 0.16)',
                      '&:hover': {
                        backgroundColor: 'rgba(63, 81, 181, 0.24)',
                      },
                    }
                  }}
                >
                  <ListItemIcon>
                    <Radio
                      checked={selectedModel === modelName}
                      onChange={() => setSelectedModel(modelName)}
                    />
                  </ListItemIcon>
                  <Box sx={{ flexGrow: 1 }}>
                    <ListItemText 
                      primary={
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography variant="subtitle1">{modelName}</Typography>
                          <Typography 
                            variant="caption" 
                            sx={{ 
                              bgcolor: details.complexity === 'Düşük' ? 'success.light' : 
                                      details.complexity === 'Orta' ? 'info.light' : 'warning.light',
                              color: details.complexity === 'Düşük' ? 'success.dark' : 
                                    details.complexity === 'Orta' ? 'info.dark' : 'warning.dark',
                              px: 1,
                              py: 0.5,
                              borderRadius: 1
                            }}
                          >
                            {details.complexity} Karmaşıklık
                          </Typography>
                        </Box>
                      }
                      secondary={details.description}
                    />
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      <strong>Avantajları:</strong> {details.advantages}
                    </Typography>
                  </Box>
                </ListItemButton>
              </ListItem>
              <Divider variant="inset" component="li" />
            </React.Fragment>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>İptal</Button>
        <Button onClick={handleSelect} variant="contained" color="primary">
          Seç
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModelSelectionDialog;